import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateFormRequest, Form, FormNoData, IFormularioConControles, UpdateFormRequest } from 'lib-base';
import { ICategory, IGetFormularioWithRespuesta, IGetNombreColumnas } from '../../shared/interfaces/database/formulario';

@Injectable({
  providedIn: 'root'
})
export class FormularioService {

  private readonly baseUrl = `${environment.apiUrl}/api/formulario`;


  constructor(private readonly http: HttpClient) { }

  public getForm(id: number): Observable<Form> {
    return this.http.get<Form>(`${this.baseUrl}/${id}`);
  }

  public findByIdAndVersion(id: number, version: number): Observable<Form> {
    return this.http.get<Form>(`${this.baseUrl}/${id}/${version}`);
  }

  public getFormsNoData(): Observable<FormNoData[]> {
    return this.http.get<FormNoData[]>(`${this.baseUrl}/no-contenido`);
  }

  public getFormNoData(id: number): Observable<FormNoData> {
    return this.http.get<FormNoData>(`${this.baseUrl}/no-contenido/${id}`);
  }

  public getFormularioConControles(formularioId: number, version: number): Observable<IFormularioConControles[]> {
    return this.http.get<IFormularioConControles[]>(`${this.baseUrl}/controles/${formularioId}/${version}`);
  }

  public getTramiteRespuesta(tramRegistroId: number): Observable<IGetFormularioWithRespuesta> {
    return this.http.get<IGetFormularioWithRespuesta>(`${this.baseUrl}/respuesta/${tramRegistroId}`);
  }

  public createForm(form: CreateFormRequest): Observable<number> {
    return this.http.post(this.baseUrl, form, { responseType: 'text' }).pipe(
      map((response: string) => Number(response))
    );
  }

  public updateForm(form: UpdateFormRequest): Observable<string> {
    return this.http.put(this.baseUrl, form, { responseType: 'text' });
  }

  public deleteForm(id: number): Observable<string> {
    return this.http.delete(`${this.baseUrl}/${id}`, { responseType: 'text' });
  }

  public downloadFormFile(radicado: string, fileName: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/descargar/${radicado}/${fileName}`, { responseType: 'blob' });
  }

  public getNombreColumnas(formularioId: number): Observable<IGetNombreColumnas[]> {
    return this.http.get<IGetNombreColumnas[]>(`${this.baseUrl}/columnas/${formularioId}`);
  }

  public getCategoriesAvailable(): Observable<ICategory[]> {
    return this.http.get<ICategory[]>(`${this.baseUrl}/categories`);
  }
  //#region Historico
  public getFormularioHistorico(formularioId: number): Observable<FormNoData[]> {
    return this.http.get<FormNoData[]>(`${this.baseUrl}/${formularioId}/historico`);
  }

  public getFormularioHistoricoEliminado(): Observable<FormNoData[]> {
    return this.http.get<FormNoData[]>(`${this.baseUrl}/historico/eliminado`);
  }
  //#endregion Historico

  public findSubformularioReferenceias(subformularioId: number): Observable<FormNoData[]> {
    return this.http.get<FormNoData[]>(`${this.baseUrl}/subformulario/${subformularioId}/referencias`);
  }
}
